export default {
    install(Vue) {
        Vue.prototype.$iconData = (icon, enigmaIcon) => {
            return {
                'icon-pack': process.env.VUE_APP_ICONS,
                icon: /^uicons/.test(process.env.VUE_APP_ICONS) ? enigmaIcon : icon
            }
        }

        Vue.prototype.$iconDataFromMenu = icon => {
            return {
                'icon-pack': process.env.VUE_APP_ICONS,
                icon
            }
        }

        return Vue
    }
}
